var render, staticRenderFns
import script from "./WikiData.vue?vue&type=script&lang=ts"
export * from "./WikiData.vue?vue&type=script&lang=ts"
import style0 from "./WikiData.vue?vue&type=style&index=0&id=025e8a60&prod&lang=postcss"
import style1 from "./WikiData.vue?vue&type=style&index=1&id=025e8a60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports